import React, {useState} from 'react'
import styled from 'styled-components'
import logo from '../assets/LogoMe.png'
import menu from '../assets/menu.png'
import goup from '../assets/goup.png'
let color;

function Nav() {

  // change nav color when scrolling
  let [color, setColor] = useState(false)
  const changeColor = () => {
    if (window.scrollY > 90) {
      setColor(true)
    } else {
      setColor(false)
    }
  }

  //Hide Nav at certain width
  const [showTB,setShowTB] = useState("none");

    async function ShowTB(){
      if(showTB==="none"){
        setShowTB("unset");
      }else{
        setShowTB("none");
      }
    }

  window.addEventListener('scroll', changeColor)

  return (
    <div>
      <NavB style={color?{backgroundColor:"#222222"}:{}}>
        <NameCont>
          <img src={logo} style={color?{height:"3vh"}:{}} />
          <h1 style={color?{fontSize:"1.5em"}:{}}>Mohammed Arfa Uruj</h1>
        </NameCont>
        <Loc>
          <a href='#about'>About</a>
          <a href='#work'>Work</a>
          <a href='#project'>Projects</a>
          <a href='#contact'>Contact</a>
        </Loc>
      </NavB>
      <TolBar>
        <MobCont>
          <div>
            <LogoImg src={logo} />
            <p>Mohammed Arfa Uruj</p>
          </div>
          <MenuImg src={menu}  onClick={ShowTB}/>
        </MobCont>
        <ul style={{display: `${showTB}`}}>
          <li><a href='#about'>About</a></li>
          <li><a href='#work'>Work</a></li>
          <li><a href='#project'>Projects</a></li>
          <li><a href='#contact'>Contact</a></li>
        </ul>
      </TolBar>
      <UpCont>
        <a href='#intro' style={color?{opacity:1}:{opacity:0}}>
          <img src={goup} alt='Go to top'/>
        </a>
      </UpCont>
    </div>
  )
}

export default Nav

const UpCont = styled.div`
  position: fixed;
  transition: all 0.1s ease-in;
  bottom: 0;
  right: 0;
  margin-right: 3vh;
  margin-bottom: 3vh;
  z-index: 9;
  &:hover{
    cursor: pointer;
    img{
      filter: brightness(45%);
    }
  }
  img{
    height: 10vh;
    border-radius: 50%;
  }
  animation: 0.5s infinite alternate slidein;
  @keyframes slidein{
      0%{
          transform: translateY(-20%);
      }
      100%{
          transform: translateY(0);
      }
  }
`

const LogoImg = styled.img`
  height: 5vh;
  margin-right: 2vh;
  @media (max-width: 280px){
    height: 4vh;
  }
`

const MenuImg = styled.img`
  height: 5vh;
  @media (max-width: 280px){
    height: 3vh;
  }
`

const NameCont = styled.div`
  display: flex;
  align-items: center;
  img{
    height: 5vh;
    padding-right: 5px;
  }
`

const TolBar = styled.div`
  display: none;
  position: fixed;
  background: #222222;
  transition: all 0.5s ease-in-out;
  top: 0;
  left: 0;
  right: 0;
  width: 100vw;
  z-index: 10;
  @media (max-width: 767px){
    display: unset;
  }
  @media (max-width: 280px){
    font-size: 0.8em;
  }
  ul{
    list-style-type: none;
    li{
      padding: 3vh;
      border-top: 2px solid white;
      a{
        text-decoration: none;
        padding: 1vw;
        color: white;
      }
    }
    &:hover{
      cursor: pointer;
    }
  }
`

const MobCont = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5vh 3vh;
  div{
    display: flex;
    align-items: center;
    color: white;
    p{
      font-size: 1em;
    }
  }
  
`

const NavB = styled.div`
  display: flex;
  align-items: center;
  color: #f0f0f0;
  justify-content: space-evenly;
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  @media (max-width: 767px){
    display: none;
  }
`

const Loc = styled.div`
  display: flex;
  align-items: center;
  a{
    text-decoration: none;
    padding: 1vw;
    color: #f0f0f0;
    &:hover{
      border-bottom: 5px solid white;
      cursor: pointer;
    }
  }
`